<script>
import Vue from 'vue'
import Isotope from 'isotope-layout';
import Packery from 'isotope-packery';
window.FontFaceObserver = require('fontfaceobserver');


export default {
    name: 'lineup',
    props: {
        max: Number,
    },
    data: function() {
        return {
            selectedDay: null,
            selectedCat: null,
            isotopes: [],
            maxNumber: this.max,
            allShown: false,
        }
    },


    mounted: function() {
        let self = this;

        let tiers = self.$el.getElementsByClassName('js-isotope');
        for (let i = 0; i < tiers.length; i++) {
            let iso = new Isotope(tiers[i], {
                layoutMode: 'packery',
                itemSelector: '.lineup-artist'
            });
            self.isotopes.push(iso);
        }


        window.onresize = function () {
            self.redrawIsotopes();
        };
    },


    beforeDestroy() {
        for (let i = 0; i < this.isotopes.length; i++) {
            this.isotopes[i].destroy();
        }
    },


    methods: {
        showCat: function(term_id) {
            let self = this;

            term_id = parseInt(term_id);

            if (self.selectedCat === term_id) {
                self.selectedCat = null;
            } else {
                self.selectedCat = term_id;
            }

            Vue.nextTick(function() {
                self.redrawIsotopes();
                self.setFirstOnLine();
            })
        },


        showDay: function(term_id) {
            let self = this;

            term_id = parseInt(term_id);

            if (self.selectedDay === term_id) {
                self.selectedDay = null;
            } else if (term_id === 0) {
                self.selectedDay = null;
            } else {
                self.selectedDay = term_id;
            }

            Vue.nextTick(function() {
                self.redrawIsotopes();
                self.setFirstOnLine();
            })
        },


        isCatSelected: function(term_ids) {
            let self = this;

            return term_ids.includes(self.selectedCat);
        },


        isDaySelected: function(term_ids) {
            let self = this;

            return term_ids.includes(self.selectedDay);
        },


        noCatSelected: function() {
            return this.selectedCat == null;
        },


        noDaySelected: function() {
            return this.selectedDay == null;
        },


        artistVisible: function(artist_index, term_ids) {
            let self = this;

            if (self.selectedDay && !self.isDaySelected(term_ids)) {
                return false;
            }
            if (self.selectedCat && !self.isCatSelected(term_ids)) {
                return false;
            }
            if (!self.allShown && artist_index > self.maxNumber) {
                return false;
            }

            return true;
        },


        showAll: function() {
            let self = this;

            self.allShown = true;

            Vue.nextTick(function() {
                self.redrawIsotopes();
                self.setFirstOnLine();
            })
        },


        redrawIsotopes: function() {
            for (let i = 0; i < this.isotopes.length; i++) {
                this.isotopes[i].arrange();
            }
        }
    }

};

</script>